import React from "react";
import CountUp from "react-countup";

export default function StatsCards() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 lg:gap-6 z-10 w-full px-4 lg:px-8">
      {/* Card 1: Total Awards */}
      <div
        className="bg-white p-6 sm:p-8 text-center shadow-lg rounded-md"
        data-aos="zoom-out"
      >
        <div className="text-gray-500 text-sm md:text-base">Ø01</div>
        <div className="text-lg font-semibold mt-2">Total Awards</div>
        <div className="text-4xl md:text-5xl font-bold mt-4">
          <CountUp start={0} end={100} duration={8} delay={0.01} />+
        </div>
      </div>

      {/* Card 2: Years of Services */}
      <div
        className="bg-white p-6 sm:p-8 text-center shadow-lg rounded-md"
        data-aos="zoom-out"
      >
        <div className="text-gray-500 text-sm md:text-base">Ø02</div>
        <div className="text-lg font-semibold mt-2">Years of Services</div>
        <div className="text-4xl md:text-5xl font-bold mt-4">
          <CountUp start={0} end={10} duration={8} delay={0.01} />+
        </div>
      </div>

      {/* Card 3: Location */}
      <div
        className="bg-white p-6 sm:p-8 text-center shadow-lg rounded-md"
        data-aos="zoom-out"
      >
        <div className="text-gray-500 text-sm md:text-base">Ø03</div>
        < div className="text-lg font-semibold mt-2">Location</div>
        <div className="text-4xl md:text-5xl font-bold mt-4">
          <CountUp start={0} end={10} duration={8} delay={0.01} />+
        </div>
      </div>

      {/* Card 4: Team members */}
      <div
        className="bg-white p-6 sm:p-8 text-center shadow-lg rounded-md"
        data-aos="zoom-out"
      >
        <div className="text-gray-500 text-sm md:text-base">Ø04</div>
        <div className="text-lg font-semibold mt-2">Team members</div>
        <div className="text-4xl md:text-5xl font-bold mt-4">
          <CountUp start={0} end={100} duration={8} delay={0.01} />+
        </div>
      </div>

      {/* Card 5: Happy Clients */}
      <div
        className="bg-white p-6 sm:p-8 text-center shadow-lg rounded-md"
        data-aos="zoom-out"
      >
        <div className="text-gray-500 text-sm md:text-base">Ø05</div>
        <div className="text-lg font-semibold mt-2">Happy Clients</div>
        <div className="text-4xl md:text-5xl font-bold mt-4">
          <CountUp start={0} end={10000} duration={8} delay={0.01} />+
        </div>
      </div>
    </div>
  );
}